

/*******************************************************************************************
 * jquery.wh.typeahead.js
 * Plugin ersetzt Inputfelder durch Typeahead Ajax
 * @autor   Cornelius Rittner
 * @date    09.12.2010
 * @version 1.0
 * @lastmodified 09.12.2010
 *
 * Beispiel f�r Typeahead XML Code:
	<ajax_response>
		<success>true</success>
		<message></message>
		<results>xmlFormat(Ihre Suche ergab eine Million Ergebnisse!<br /><a href="http://www.google.de">zu Google</a>)#</results>
	</ajax_response>
 *
 * Um beim Laden der Webseite gew�nschten Inputs durch die Ajax-Versionen zu ersetzen,
 * muss die Funktion in die allgemeine Javascript-Datei der Seite eingesetzt werden.
 * Beispiel wie das aussehen kann:
 *
	$(document).ready(function() {
		$("#schnellsuche input[name='suche']").typeahead({ ajaxurl: "/ajax_suche.html" });
	});
 *
 *******************************************************************************************/

jQuery.fn.wh_typeahead = function(options) {
	/***************************************************************************************
	 * Default Options
	 ***************************************************************************************/
	var defaults = {
		 ajaxurl:			"/ajax/typeahead"
		,searchparameter:	"s"
		,width:				0
		,left:				0
		,top:				0
		,nav_id:			1
		,page_id:			1
		,fachbereich:		0
		,container:			"body"
		,sprache:			"de"
		,defaultstring: 	"Suchen"
		,id_add:			""
		,is_academy_page: 	0
	};
	/***************************************************************************************
	 * Initialisierung
	 ***************************************************************************************/
	var options = $.extend({}, defaults, options);
	$(this).each(function() {
		var $input = $(this);
		var timeouts = new Object();
		var ajax_link = -1;
		var hide_results_focus = false;	// Wenn Focus auf dem Eingabefeld liegt, Ergebnis anzeigen
		var hide_results_hover = true;	// Wenn Focus auf der Ergebnisliste liegt, Ergebnis anzeigen
		var selector_id = "ajax_results"+options.id_add;

		// Ueberpruefen, ob defaultstring uebergeben wurde, sonst abhaengig von Sprache setzen
		if(options.defaultstring == "Suchen") {
			if (options.sprache == "de") {
				options.defaultstring = "Suchen"
			} else {
				options.defaultstring = "Search"
			}
		}
		$input.attr({autocomplete:"off",value:options.defaultstring});

		// Focus Input
		$input.focus(function() {
			if ($(this).attr("value") == options.defaultstring) {
				$(this).attr("value","");
			}

			hide_results_focus = false;
			if ($input.val().length >=2) {
				if ($('#'+selector_id).length == 0) {
					window.clearTimeout(timeouts["ajax_result"]);
					$(options.container).prepend('<div id="'+selector_id+'" class="ajax_result_class"></div>');
					$('#'+selector_id).css({
						position: 'absolute'
						,right: ((options.right !== false) ? options.right : $input.offset().right) + 'px'
						,top: ((options.top !== false) ? options.top : ($input.offset().top + $input.height() + 2)) + 'px'
						,width: ( ( options.width == 0 ) ? $input.outerWidth() + 'px' : options.width )
						,'z-index': 210
						,display: 'none'
					});
					$('#'+selector_id).addClass("typeahead");
				}
				if ($('#'+selector_id).length > 0) {
					if ($('#'+selector_id).css("display") == "none") {
						$('#'+selector_id).slideDown();
						$('#'+selector_id).addClass("typeahead");
					}
					$('#'+selector_id).hover(function(){
						hide_results_hover = false;
					},function(){
						hide_results_hover = true;
						timeouts["ajax_result"] = window.setTimeout(function(){
							if ($('#'+selector_id) && hide_results_focus && hide_results_hover) {
								$('#'+selector_id).fadeOut();
							}
						},300);
					});
				}
			}
		});

		// Blur Input
		$input.blur(function(){
			if ($(this).attr("value") == "") {
				$(this).attr("value",options.defaultstring);
			}
			hide_results_focus = true;
			timeouts["ajax_result"] = window.setTimeout(function(){
				if ($('#'+selector_id) && hide_results_focus && hide_results_hover) {
					$('#'+selector_id).fadeOut();
				}
			},300);
		});

		// KeyUp on Input (when key is released)
		$input.keyup(function(e){
			var key = e.charCode || e.keyCode || 0;
			if (key != 37 && key != 38 && key != 39 && key != 40 && key != 13) {
				// do nothing when arrowkeys (37-40) or enter, else clear Timeout and run Ajax
				window.clearTimeout(timeouts["ajax_search"]);
				timeouts["ajax_search"] = window.setTimeout(function(){
						if ($input.val().length >=2) {
							var timestamp = new Date();
							$.ajax({
								type: 'GET',
								url: options.ajaxurl,
								data: options.searchparameter + '=' + encodeURIComponent($input.val()) + '&timestamp=' + encodeURIComponent(timestamp*1) + '&page_id=' + options.page_id + '&nav_id=' + options.nav_id + '&sprache=' + options.sprache + "&fachbereich=" + options.fachbereich + "&is_academy_page=" + options.is_academy_page,
								success: function(xml,textStatus) {
									ajax_link = -1;
									if ($('#'+selector_id).length == 0) {
										window.clearTimeout(timeouts["ajax_result"]);
										$(options.container).prepend('<div id="'+selector_id+'" class="ajax_result_class"></div>');
										$('#'+selector_id).css({
											position: 'absolute'
											,right: ((options.right !== false) ? options.right : $input.offset().right) + 'px'
											,top: ((options.top !== false) ? options.top : ($input.offset().top + $input.height() + 2 + 'px'))
											,width: ( ( options.width == 0 ) ? $input.outerWidth() + 'px' : options.width )
											,'z-index': 210
											,display: 'none'
										});
										$('#'+selector_id).addClass("typeahead");
									}
									if ($('success', xml).text() == 'true') {
										// Suche erfolgreich
										$('#'+selector_id).html($('results', xml).text());
									} else if ($('success', xml).text() == 'false') {
										$('#'+selector_id).html($('message', xml).text());
									}
									if ($('#'+selector_id).css("display") == "none") {
										$('#'+selector_id).slideDown();
										$('#'+selector_id).addClass("typeahead");
									}
									$('#'+selector_id).hover(function(){
										hide_results_hover = false;
									},function(){
										hide_results_hover = true;
										timeouts["ajax_result"] = window.setTimeout(function(){
											if ($('#'+selector_id) && hide_results_focus && hide_results_hover) {
												$('#'+selector_id).fadeOut();
											}
										},300);
									});
								},
								error: function (XMLHttpRequest, textStatus, errorThrown) {}
							});
						}
				},200);
			}
		});

		// KeyDown on Input (when keys are pressed, e.g. arrowkeys)
		$input.keydown(function(e){
			var key = e.charCode || e.keyCode || 0;
			if (key == 40 && $('#'+selector_id).length != 0) {
				// arrowkey down
				if (ajax_link == -1) {
					ajax_link = 0;
				} else {
					// remove highlight from element
					$('#'+selector_id+' a:eq('+ajax_link+')').removeClass("ajaxfocus");
					if (ajax_link == $('#'+selector_id+' a').length-1) {
						ajax_link = 0;
					} else {
						ajax_link++;
					}
				}
				// highlight element
				$('#'+selector_id+' a:eq('+ajax_link+')').addClass("ajaxfocus");
			} else if (key == 38) {
				// arrowkey up
				if (ajax_link == -1) {
					ajax_link = 0;
				} else {
					// remove highlight from element
					$('#'+selector_id+' a:eq('+ajax_link+')').removeClass("ajaxfocus");
					if (ajax_link == 0) {
						ajax_link = $('#'+selector_id+' a').length-1;
					} else {
						ajax_link--;
					}
				}
				// highlight element
				$('#'+selector_id+' a:eq('+ajax_link+')').addClass("ajaxfocus");
			} else if (key == 13 && ajax_link != -1) {
				// enter key, sets Window-Location
				window.location.href = $('#'+selector_id+' a:eq('+ajax_link+')').attr("href");
				return false;
			}
		});
	});
	return this;
}